import { PopOver as AntdPopOver } from "@empglabs/backoffice-ui-kit"

const PopOver = props => {
  return <AntdPopOver {...props} />
}

export default PopOver
